// テナント管理者ガード - role=tenantAdmin / userType=Maintainer 以外はテナント一覧へリダイレクト
// 親ルートの tenantGuard が MeStore のロードと tenantId 存在チェック済みの前提で動作する
import { inject } from '@angular/core';
import {
  Router,
  type ActivatedRouteSnapshot,
  type CanActivateFn,
  type RouterStateSnapshot,
} from '@angular/router';

import { TenantsStore } from '../tenants.store';
import { isTenantAdmin } from '../tenants.utils';

export const tenantAdminGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
) => {
  const tenantsStore = inject(TenantsStore);
  const router = inject(Router);

  const tenantId = route.params['tenantId'] as string | undefined;
  const tenant = tenantId
    ? tenantsStore.tenants().find((t) => t.publicId === tenantId)
    : undefined;

  if (tenant && isTenantAdmin(tenant)) {
    return true;
  }

  return router.createUrlTree(['/tenants']);
};
